require('./bootstrap');
window.Echo.channel('global-notifications')
    .listen('SendNotification', (e) => {
        alert(e.message);
    });


